
import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="bg-dark text-white text-center py-4">
      <Container>
        <p className="mb-0">&copy; {new Date().getFullYear()} SigisBell. All rights reserved.</p>
        <p className="mb-0">Email: shyllon147@gmail.com | Phone: 943-223-0218 | Address: 6030 Hwy 85 suite 112, Riverdale, GA 30274</p>
      </Container>
    </footer>
  );
}

export default Footer;
